import { useQuery } from "@tanstack/react-query";

import type { ValidatorsSortingBy } from "services/marinade/fetchAllValidators";
import { fetchAllValidators } from "services/marinade/fetchAllValidators";

interface QueryParams {
  searchTerm?: string;
  ids?: string[];
  offset?: number;
  limit?: number;
  epochs?: number;
  onlyWithMarinadeStake?: boolean;
  enabled?: boolean;
  from_datetime?: string;
  sortBy?: ValidatorsSortingBy;
}

export const useAllValidators = ({
  searchTerm,
  ids,
  offset,
  limit = 9999,
  epochs,
  onlyWithMarinadeStake,
  enabled = true,
  from_datetime,
  sortBy,
}: QueryParams) => {
  const queryId = [
    "allValidators",
    limit,
    searchTerm ?? "",
    ids,
    offset,
    epochs,
    onlyWithMarinadeStake,
    from_datetime,
    sortBy,
  ]
    .filter((v) => !!v)
    .join(",");
  return useQuery(
    [queryId],
    () =>
      fetchAllValidators(
        limit,
        searchTerm,
        epochs,
        ids,
        onlyWithMarinadeStake,
        from_datetime,
        sortBy
      ),
    {
      staleTime: 1000 * 60 * 60,
      cacheTime: 1000 * 60 * 60,
      refetchInterval: 1000 * 60 * 60,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      enabled,
    }
  );
};
